import React, { useState, useEffect } from "react";

interface TimeLeft {
  hours: number;
  minutes: number;
  seconds: number;
}

export default function SpecialOfferBanner() {
  const [timeLeft, setTimeLeft] = useState<TimeLeft>({
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    // Set countdown to 59 minutes from now
    const calculateTimeLeft = () => {
      const now = new Date().getTime();
      const endTime = now + 59 * 60 * 1000; // 59 minutes from now

      // Check if we have an existing end time in localStorage
      const savedEndTime = localStorage.getItem("offerEndTime");
      let targetTime: number;

      if (savedEndTime) {
        targetTime = parseInt(savedEndTime);
        // If the saved time has passed, reset to 59 minutes from now
        if (targetTime <= now) {
          targetTime = endTime;
          localStorage.setItem("offerEndTime", targetTime.toString());
        }
      } else {
        targetTime = endTime;
        localStorage.setItem("offerEndTime", targetTime.toString());
      }

      const difference = targetTime - now;

      if (difference > 0) {
        const hours = Math.floor(
          (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
        );
        const minutes = Math.floor(
          (difference % (1000 * 60 * 60)) / (1000 * 60),
        );
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);

        return { hours, minutes, seconds };
      }

      return { hours: 0, minutes: 0, seconds: 0 };
    };

    // Update immediately
    setTimeLeft(calculateTimeLeft());

    // Update every second
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatNumber = (num: number) => num.toString().padStart(2, "0");

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 py-3 px-4 shadow-lg border-t"
      style={{ backgroundColor: "#ecb22d" }}
    >
      <div className="container mx-auto max-w-7xl flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-center">
        <div className="flex items-center gap-2">
          <span className="text-lg">🚨</span>
          <span className="text-white font-semibold text-sm sm:text-base">
            Limited offer: Start your trial now and get{" "}
            <span className="font-bold underline">50% off for life</span> on the
            Starter plan
          </span>
        </div>

        <div className="flex items-center gap-2 bg-black/30 rounded-lg px-3 py-1 backdrop-blur-sm">
          <span className="text-white text-xs sm:text-sm font-medium">
            Expires in:
          </span>
          <div className="flex items-center gap-1 text-white font-bold text-sm sm:text-base">
            {timeLeft.hours > 0 && (
              <>
                <span className="min-w-[2rem] text-center">
                  {formatNumber(timeLeft.hours)}
                </span>
                <span>:</span>
              </>
            )}
            <span className="min-w-[2rem] text-center">
              {formatNumber(timeLeft.minutes)}
            </span>
            <span>:</span>
            <span className="min-w-[2rem] text-center">
              {formatNumber(timeLeft.seconds)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
